import { render, staticRenderFns } from "./dlgExportAdvice.vue?vue&type=template&id=4a254e83"
import script from "./dlgExportAdvice.vue?vue&type=script&lang=js"
export * from "./dlgExportAdvice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports